import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { SmsTemplate } from "@rumble-it/common-lib/types/models/SmsTemplate.interface";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

export const smsTemplateColumns: TableColumnsType<SmsTemplate> = [
  {
    title: "Titel",
    dataIndex: "title",
    key: "title",
    render: (_: any, record: any) => (
      <Link to={`/sms-templates/${record.id}`}>{record.title}</Link>
    ),
  },
  {
    title: "Taal",
    dataIndex: "language",
    key: "language",
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record) => (
      <Link to={`/sms-templates/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
